import React from "react";
import {notification} from "antd";
import {Icon as LegacyIcon} from "@ant-design/compatible";
import {store} from "../helper/store";
import {notNull} from "./utils";
import {specimenType} from "./const";

const systemStateDict = {
    CRITICAL : "CRITICAL",
    WARNING : "WARNING",
    AVAILABLE : "AVAILABLE"
}
const notificationTypeDict = {
    HDD : 'hdd',
    SSD : 'ssd',
    STOP : 'stop',
    CRASHED: 'crashed'
}

const getNotificationTitle = (stateVariable, type) => {
    let title;
    if(type === notificationTypeDict.SSD){
        if(stateVariable.ssdStatus === systemStateDict.WARNING){
            title = "Low Disk Space on SSD";
        } else if (stateVariable.ssdStatus === systemStateDict.CRITICAL){
            title = "Critically Low Disk Space on SSD";
        }
    }else if(type === notificationTypeDict.HDD){
        if(stateVariable.hddStatus === systemStateDict.WARNING){
            title = "Low Disk Space on HDD";
        } else if (stateVariable.hddStatus === systemStateDict.CRITICAL){
            title = "Critically Low Disk Space on HDD";
        }
    }else if(type === notificationTypeDict.STOP){
        title = "Cancelling Scan"
    }else if(type === notificationTypeDict.CRASHED && stateVariable?.crashedScan?.scanName){
        title = stateVariable.crashedScan.scanName
    }
    return title;
}

const getNotificationText = (stateVariable, type) => {
    let text;
    if(type === notificationTypeDict.SSD){
        if(stateVariable.ssdStatus === systemStateDict.WARNING){
            text = "Please delete unwanted items from SSD for smoother scanning.";
        } else if (stateVariable.ssdStatus === systemStateDict.CRITICAL){
            text = "Please analyze and make disk space on SSD to regain access to scanning.";
        }
    }else if(type === notificationTypeDict.HDD){
        if(stateVariable.hddStatus === systemStateDict.WARNING){
            text = "Please consider deleting some scans or upload scans to cloud.";
        } else if (stateVariable.hddStatus === systemStateDict.CRITICAL){
            text = "Delete scans or upload to cloud to regain access to scanning.";
        }
    }else if(type === notificationTypeDict.STOP){
        text = "Critically Low Disk Space. Scans are cancelled.\n Please free up space to continue scanning.";
    }else if(type === notificationTypeDict.CRASHED && stateVariable?.crashedScan?.message){
        text = stateVariable.crashedScan.message;
    }
    return (<div>{text}<br></br>{"Please contact support for further help."}</div>);
}


const closeNotification = (key) => {
    notification.close(key);
};

const isObjEmpty = (obj) => {
    for(var key in obj) {
        if(obj.hasOwnProperty(key))
            return false;
    }
    return true;
}

const openSystemStateNotification = (key, systemState, type) => {
    if(!isObjEmpty(systemState)){
        notification.open({
            key,
            message: getNotificationTitle(systemState, type),
            icon: <LegacyIcon type={type === notificationTypeDict.HDD || type === notificationTypeDict.SSD ? 'hdd':'frown'} 
            style={{color: (systemState.hddStatus === systemStateDict.WARNING && type === notificationTypeDict.HDD) || 
                    (systemState.ssdStatus === systemStateDict.WARNING && type === notificationTypeDict.SSD) ? 
                "#EA8D16" : "#FF0000"}} ></LegacyIcon>,
            duration: 0,
            description: getNotificationText(systemState, type),
            placement: 'bottomRight',
        });
    }
};

export const checkSystemState = (deviceStatus) => {
    deviceStatus = deviceStatus[1];
    let scannerStatus = (((deviceStatus || {}).scanner_health || {}).scanner_response || {});
    let systemState = ((scannerStatus || {}).systemState || {});

    if (systemState.hddStatus === systemStateDict.CRITICAL || systemState.ssdStatus === systemStateDict.CRITICAL || systemState.stoppingScan === true) {
        return true;
    }
    return false;
}

export const systemStateNotificationHandler = (systemState) => {
    const systemNotifierKeySSD = "systemNotificationSSD";
    const systemNotifierKeyHDD = "systemNotificationHHD";
    const systemNotifierKeyStop = "systemNotificationStop";
    const systemNotifierKeyCrashed = "systemNotificationCrashed";

    if(systemState.ssdStatus !== systemStateDict.AVAILABLE){
        openSystemStateNotification(systemNotifierKeySSD, systemState, notificationTypeDict.SSD)
    }else{
        closeNotification(systemNotifierKeySSD)
    }
    if(systemState.hddStatus !== systemStateDict.AVAILABLE){
        openSystemStateNotification(systemNotifierKeyHDD, systemState, notificationTypeDict.HDD)
    }else{
        closeNotification(systemNotifierKeyHDD)
    }
    if(systemState.stoppingScan === true){
        openSystemStateNotification(systemNotifierKeyStop, systemState, notificationTypeDict.STOP)
    }else{
        closeNotification(systemNotifierKeyStop)
    }
    
    let crashedScantimeStamp = (((systemState || {}).crashedScan || {}).timeStamp || 0)
    if(crashedScantimeStamp !== 0){
    localStorage.setItem("crashedScanTimeStamp", crashedScantimeStamp)
    }
    if(((crashedScantimeStamp !== 0) && (Date.now() - 10000 < (localStorage.getItem("crashedScanTimeStamp") || 0)))){
        openSystemStateNotification(systemNotifierKeyCrashed, systemState, notificationTypeDict.CRASHED)
        localStorage.setItem("crashedScanTimeStamp", crashedScantimeStamp)
    }
}

export const scanPageSelector = (deviceId) => {
    const status = store.getState().deviceStatusReducer[deviceId]?.scanner_health?.scanner_response?.scanPreviewStatus;
    const cassetteStatus = store.getState().deviceStatusReducer[deviceId]?.scanner_health?.scanner_response?.currentCassetteStats;
    let isBloodScan = false;
    if (notNull(cassetteStatus) && Object.values(cassetteStatus).length > 0){
        isBloodScan = Object.values(cassetteStatus).some(
                (statusKey) => statusKey?.specimenType === specimenType.BLOOD);
    } else if (notNull(status) && Object.keys(status).length > 0){
        isBloodScan = Object.values(status).some(
                (statusKey) => statusKey?.previewResponse?.specimenType === specimenType.BLOOD);
    }
    return isBloodScan ? "blood-scan" : "scan";
}